export default "__VITE_ASSET__DWrEqH2e__"